import { useEffect, useState } from 'react'

const getOnlineStatus = () =>
  typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined'
    ? true
    : navigator.onLine

const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(getOnlineStatus)

  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOnline(getOnlineStatus())
    }

    window.addEventListener('online', updateOnlineStatus)
    window.addEventListener('offline', updateOnlineStatus)

    return () => {
      window.removeEventListener('online', updateOnlineStatus)
      window.removeEventListener('offline', updateOnlineStatus)
    }
  }, [])

  return {
    isOnline,
    isOffline: !isOnline,
  }
}

export default useNetworkStatus
